import React, { useEffect, useState } from "react";
import { Grid, Box, Typography, Avatar, Radio } from "@mui/material";
import "./GiveFeedbackModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import CompDirection from "../../../themes/CompDirection";
import { fonts } from "../../../themes/themes";
import CustomAutoComplete from "../../../components/CustomAutoComplete/CustomAutoComplete";
import SearchComponent from "../../../components/SearchComponent";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;

  trans?: any;
}

const GiveFeedbackModalPresenter = ({
  isModalOpen,
  closeModal,

  trans,
}: ModalProps) => {
  const options = [
    { label: 'Downward', value: 1 },
    { label: 'Steady', value: 2 },
    { label: 'Upward', value: 3 },
];
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="fitContent"
      modalWidth="60%"
      padding="1em"
    >
      <ModalHeader
        fontWeight="500"
        fontSize="28px"
        modal={{ modal_title: trans("Give Feedback") }}
        closeModal={closeModal}
        onClickBack={closeModal}
      />
      <CompDirection>
        <Grid spacing={2} container sx={{}}>
          <Grid item xs={12} md={6}>
            <Box
              style={{
                border: "1px solid #0000001F",
                padding: "2em",
                borderRadius: "7px",maxHeight:"646px",overflowY:"auto"
              }}
            >
              {" "}
              <Grid spacing={2} container>
                <Grid item xs={6}>
                  <Typography
                    style={{
                      color: "#000000",
                      fontFamily: fonts.fontFamily,
                      fontSize: "1em",
                      fontWeight: "bold",
                      textTransform:"uppercase"
                    }}
                  >
                    {trans("Select Employees")}
                  </Typography>
                  <Typography
                    style={{
                      color: "#575757",
                      fontFamily: fonts.fontFamily,
                      fontSize: "0.725em",
                    }}
                  >
                    {trans("Total Employees:")} 7,225
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Box>
                    <CustomAutoComplete
                      label="Select Option"
                      size="medium"
                      required={false}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box style={{ marginTop: "0.5em" }}>
                    <SearchComponent />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box style={{ marginTop: "0.5em" }}>
                    {[
                      { id: 8987, name: "Amelia gg" },
                      { id: 1542, name: "Tapook Lio" },
                      { id: 6875, name: "Othman Api" },
                      { id: 3624, name: "Arib Gozeel" },
                      { id: 1152, name: "Durkhush Falo" },
                    ].map((data: any, index: any) => {
                      return (
                        <Grid
                          container
                          spacing={1}
                          marginBottom="15px"
                          key={data?.id}
                          style={{
                            display: "flex",
                            alignItems: "center",
                            fontFamily: fonts.fontFamily,
                          }}
                        >
                          <Grid item xs={3}>
                            <Radio />
                          </Grid>
                          <Grid item xs={3}>
                            <Typography
                              style={{
                                fontSize: "0.75em",
                                color: "#575757",
                                fontFamily: fonts.fontFamily,
                              }}
                            >
                              {" "}
                              {data?.id}
                            </Typography>
                          </Grid>
                          <Grid item xs={3}>
                            <Avatar />
                          </Grid>
                          <Grid item xs={3}>
                            <Typography
                              style={{
                                fontSize: "0.75em",
                                color: "#081735",
                                fontWeight: "bold",
                              }}
                            >
                              {data?.name}
                            </Typography>
                          </Grid>
                        </Grid>
                      );
                    })}
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              style={{
                border: "1px solid #0000001F",
                padding: "2em",
                borderRadius: "7px",
              }}
            >
              <Typography
                style={{
                  color: "#575757",
                  fontFamily: fonts.fontFamily,
                  fontSize: "1em",
                  fontWeight: "bold",
                  textTransform:"uppercase"
                }}
              >
                {trans("Feedback For")}
              </Typography>
               <Grid spacing={1} container sx={{marginTop: "1em"}}>
              <Grid item xs={6}>
                <Box
                  style={{
                    border: "1px solid #D8D8D8",
                    display: "flex",
                    alignItems: "center",
                    padding: "0.2em",
                    borderRadius: "5px",
                    textTransform: "uppercase"
                  }}
                >
                  
                  <Radio />
                  <Typography
                    style={{
                      color: "black",
                      fontFamily: fonts.fontFamily,
                      fontSize: "0.75em",
                    }}
                  >
                    {trans("Goals")}
                  </Typography>
                </Box>
                </Grid>
                <Grid item xs={6}>
                <Box
                  style={{
                    border: "1px solid #D8D8D8",
                    display: "flex",
                    alignItems: "center",
                    padding: "0.2em",
                    borderRadius: "5px",
                    textTransform: "uppercase"
                  }}
                >
                  <Radio />
                  <Typography
                    style={{
                      color: "black",
                      fontFamily: fonts.fontFamily,
                      fontSize: "0.75em",
                    }}
                  >
                    {trans("KPIs")}
                  </Typography>
                </Box>
              </Grid>
              </Grid>
              <Box style={{ marginTop: "1em" }}>
                <CustomAutoComplete label="Select Goal" size="medium" required={false}/>
              </Box>
              <Box style={{ marginTop: "1em" }}>
                <CustomAutoComplete label="Select Task"  size="medium" required={false}/>
              </Box>
              <Box style={{ marginTop: "1em" }}>
                <CustomTextField type="string" label="Feedback"  placeholder="Write Feedback Here"  rows={5}
                  multiline={true}/>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
      <ModalFooter
        onClickCancel={() => {
          closeModal();
        }}
        onClickSubmit={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default GiveFeedbackModalPresenter;
